import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RegisterOptions, UseFormReturn } from "react-hook-form";
import { useGlobalData } from "../../GlobalDataProvider";
import { getValueByString } from "../Utils";
import { Controller } from "react-hook-form";
import { NumericFormat, NumericFormatProps } from "react-number-format";
import { useRef } from "react";

interface IProps {
  label: string;
  fieldName: string;
  formHook: UseFormReturn;
  options?: RegisterOptions;
  children?: React.ReactNode;
  step?: number;
  tooltipId?: string;
  isDisabled?: boolean;
  showWhenIsDisabled?: boolean;
  min?: number;
  max?: number;
  required?: boolean;
  tooltipCallBack?: () => string | undefined;
  formatOptions?: NumericFormatProps;
  isPercentage?: boolean;
}

const FormattedNumberEditor = ({
  label,
  fieldName,
  formHook,
  options,
  step,
  children,
  tooltipId,
  isDisabled,
  showWhenIsDisabled,
  min,
  max,
  required,
  tooltipCallBack,
  formatOptions,
  isPercentage,
}: IProps) => {
  const { formState, control } = formHook;
  const inputRef = useRef<HTMLInputElement | null>(null);

  const globalData = useGlobalData();
  const errors = formState.errors;
  const defaults = { decimalSeparator: ",", thousandSeparator: " " };
  formatOptions = { ...defaults, ...(formatOptions || {}) };
  if (isPercentage) formatOptions.suffix = " %";

  const isInValid: any = getValueByString(errors, fieldName);

  options = options || {};
  if (options) {
    if (!options.valueAsNumber && !options.setValueAs) options.valueAsNumber = true;
  }
  if (min !== undefined) options.min = min;
  if (max !== undefined) options.max = max;
  if (required) options.required = "Du måste ange ett värde";

  const renderTooltip = (props: any) => {
    if (isInValid)
      return (
        <Tooltip {...props} className="validationErrorTooltip">
          <span>{isInValid.message}</span>
        </Tooltip>
      );
    if (tooltipCallBack)
      return (
        <Tooltip {...props} className="defaultTooltip">
          <span style={{ whiteSpace: "pre-line" }}>{tooltipCallBack()}</span>
        </Tooltip>
      );
    else if (tooltipId && globalData.data?.Tooltip.mapTooltip[tooltipId])
      return (
        <Tooltip {...props} className="defaultTooltip">
          <span style={{ whiteSpace: "pre-line" }}>{globalData.data?.Tooltip.mapTooltip[tooltipId]}</span>
        </Tooltip>
      );
    else return <></>;
  };

  const getNumberEditor = () => {
    var htmlPart;

    //Input group base
    htmlPart = (
      <div className={(children ? "input-group" : "") + " w-100"}>
        {isDisabled && !showWhenIsDisabled ? (
          <input value={""} type="number" disabled={true} className={"form-control"} />
        ) : (
          <>
            <Controller
              control={control}
              name={fieldName}
              rules={{ ...options }}
              render={({ field }) => (
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <NumericFormat
                    className={"form-control " + (isInValid ? "is-invalid" : "")}
                    {...formatOptions}
                    // {...field}
                    name={field.name}
                    disabled={isDisabled}
                    value={field.value ?? ""}
                    onBlur={field.onBlur}
                    getInputRef={(el: any) => (inputRef.current = el)}
                    onValueChange={(values) => {
                      field.onChange(values.floatValue ?? undefined);
                    }}
                  />
                </OverlayTrigger>
              )}
            />
          </>
        )}

        {children}
        {/* {errors[fieldName]?.message && <div className="invalid-feedback">{errors[fieldName]?.message?.toString()}</div>} */}
      </div>
    );

    //Label if exists
    if (label) {
      htmlPart = (
        <label className="form-label w-100">
          {label}
          {htmlPart}
        </label>
      );
    }

    htmlPart = <div className="input-group has-validation">{htmlPart}</div>;

    return htmlPart;
  };

  return <>{getNumberEditor()}</>;
};

export default FormattedNumberEditor;
